module.exports = __webpack_public_path__ + "static/media/icon-report-sidebar-active.90d05248.svg";